var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
  'hm-teaser-box': true,
  'padded': _vm.value.padded
}},[_c('div',{class:{
    'hm-teaser-header': true,
    'padded': _vm.value.padded
  },style:({ backgroundImage:  `url(${_vm.value.img})`})},[_c('dragContainer',{attrs:{"drag-bol":false},model:{value:(_vm.value.goodData),callback:function ($$v) {_vm.$set(_vm.value, "goodData", $$v)},expression:"value.goodData"}})],1),_c('div',{class:{
    'hm-teaser-desc': true,
    'hidePadding': _vm.value.padded
  }},[_c('div',{staticClass:"hm-teaser-desc-box"},[_c('div',{staticClass:"hm-teaser-desc__title"},[_vm._v(" "+_vm._s(_vm.value.title)+" ")]),_c('div',{staticClass:"hm-teaser-desc__handle"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.value.cta.desc))]),_vm._m(0)])]),_c('div',{staticClass:"hm-teaser-desc__text"},[_vm._v(" "+_vm._s(_vm.value.content)+" ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"el-icon-arrow-right"})])
}]

export { render, staticRenderFns }